import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    label: {
      marginLeft: theme.spacing.sm,
    },
    body: {
      border: `1px solid ${colors.disabled.muted}`,
      padding: "12px",
      borderRadius: 8,
      marginBottom: 16,
      transition: "ease-in-out 0.2s",
      ":hover": {
        borderColor: colors.primary.subtle,
        backgroundColor: colors.primary.muted,
      },
    },
    bodyActive: {
      borderColor: colors.primary.subtle,
      backgroundColor: colors.primary.muted,
    },
    badge: {
      borderRadius: 4,
      padding: "0px 6px",
      backgroundColor: "#F0FDF6",
      color: "#038047",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: "18px",
    },
    image: {
      width: "72%",
      objectFit: "contain",
    },
    imageWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      objectFit: "contain",
    },

  }
});

export default useStyles;
